import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    IconButton,
    Box
} from '@mui/material';
import { Close } from '@mui/icons-material';
import MovimientosExtraordinarios from './MovimientosExtraordinarios';

/**
 * Modal wrapper para el componente MovimientosExtraordinarios
 */
const MovimientosExtraordinariosModal = ({ open, onClose }) => {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="lg" 
            fullWidth
            PaperProps={{
                sx: { height: '90vh' }
            }}
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    💰 Movimientos Extraordinarios
                    <IconButton onClick={onClose} size="small">
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ p: 0, overflow: 'hidden' }}>
                <Box sx={{ height: '100%', overflow: 'auto', p: 2 }}>
                    <MovimientosExtraordinarios />
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default MovimientosExtraordinariosModal;
